"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hyperQueryTypeSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
exports.hyperQueryTypeSchema = yup_lib_1.default.object().shape({
    selector: yup_lib_1.default.object().required(),
    queryOption: yup_lib_1.default.object().notRequired()
});
